/* eslint-disable no-unused-vars */

 

export default class DOM {
  constructor() {}

  static execCommand(cmd, showUI = false, value = null) {
    window.pdfDoc.execCommand(cmd, showUI, value);
  }

  static isCommandState(id) {
    // console.log(window.pdfDoc);
    return window.pdfDoc.queryCommandState(id) ?? false;
  }

  static isCommandValue(id) {
    return window.pdfDoc.queryCommandValue(id);
  }

  static setActive(id, type, color, target = null) {
    let activeState = DOM.isCommandState(type);
    if (type === "backColor") {
      // console.log("\t\t\t", RGBAtoHEX(DOM.isCommandValue(type)), color);
      activeState = DOM.isCommandValue(type) !== "rgb(255, 255, 255)";
    }
    // console.log(window.pdfDoc);
    window.pdfDoc.getElementById(id).style.background = activeState
      ? color
      : "";
  }

  static contains(parentId, childId) {
    return window.pdfDoc
      .getElementById(parentId)
      .contains(document.getElementById(childId));
  }
}
